export const listCompanyNameSpec = [
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Company Name',
    name: 'company',
    type: 'String',
  },
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Company ID',
    name: 'COMPANY_ID',
    type: 'Integer',
  },
]
